import React, { useContext } from "react";
//
import { useNavigate } from "react-router";
import List from "@mui/material/List";
// 語系
import { FormattedMessage, useIntl } from "react-intl";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AvatarPopup from "../../common/components/popup/AvatarPopup";
import ListItemBasic from "../../common/components/listitem/ListItemBasic";
import AvatarBasic from "../../common/components/avatar/AvatarBasic";
import ButtonPopup from "../../common/components/popup/ButtonPopup";
import { StoreContext } from "../../store/StoreProvider";
// hooks
import useLocaleRoute from "../../common/hooks/useLocaleRoute";
// config
import { ROUTE_PATH } from "../../config/CONSTANTS";
import fireAuth from "../../api/firebase/auth/utils";
import urls from "../../api/project/ApiUrls";
import featureDisplay from "../../common/utils/featureDisplay";
import IconArrowDown from "../../../images/icon_arrow_down/icon_arrow_down.png";
import LocaleSwitch from "./LocaleSwitch";

const UserAvatarPopup = () => {
  //
  const intl = useIntl();
  // route
  const navigate = useNavigate();
  // store
  const [state] = useContext(StoreContext);
  const { user } = state;
  const { displayName, email, locale, imgSrc } = user;
  // local state

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const isLoggedIn = fireAuth.isLoggedIn(user);
  const handleShowUserSetting =
    isLoggedIn && featureDisplay(process.env.REACT_APP_USER_SETTING_PUBLIC);
  const handleShowPro =
    isLoggedIn && featureDisplay(process.env.REACT_APP_UPGRADE_TO_PRO_PUBLIC);
  const handleShowLogout = isLoggedIn;
  const handleShowAdminSetting = fireAuth.isAdmin(user);
  const handleShowRootSetting = fireAuth.isRootAdmin(user);

  const getAvatarProps = () => ({
    src: imgSrc,
    letter: displayName || "",
  });

  const menuProps = {
    header: [
      {
        children: (
          <ListItemBasic
            key="header-01"
            listIcon={
              <AvatarBasic
                avatarProps={{
                  ...getAvatarProps(),
                }}
              />
            }
            textPrimary={<Typography variant="body2">{displayName}</Typography>}
            textSecondary={
              <Typography variant="caption">{email || ""}</Typography>
            }
            listItemProps={{}}
            listItemButtonProps={{}}
            listItemTextProps={{}}
          />
        ),
        useMenuItem: false,
      },
    ],
    body: [
      {
        text: intl.formatMessage({
          id: "user.avatar.user.setting",
          defaultMessage: "個人設定",
        }),
        path: handleLocaleRoute(ROUTE_PATH.UserSetting),
        show: handleShowUserSetting,
      },
      {
        text: intl.formatMessage({
          id: "user.avatar.admin.setting",
          defaultMessage: "管理者設定",
        }),
        path: handleLocaleRoute(ROUTE_PATH.AdminSetting),
        show: handleShowAdminSetting,
      },
      {
        text: intl.formatMessage({
          id: "user.avatar.root.setting",
          defaultMessage: "網站管理者設定",
        }),
        path: handleLocaleRoute(ROUTE_PATH.RootSetting),
        show: handleShowRootSetting,
      },
      {
        text: intl.formatMessage({
          id: "user.avatar.go.pro",
          defaultMessage: "升級至 Pro",
        }),
        path: handleLocaleRoute(ROUTE_PATH.Shop),
        show: handleShowPro,
      },
    ]
      .filter((item) => item.show)
      .map((item, idx) => ({
        children: (
          <ListItemBasic
            textPrimary={
              <Box px={3}>
                <Typography variant="body2">{item.text}</Typography>
              </Box>
            }
            listItemProps={{
              onClick: () => navigate(item.path),
            }}
          />
        ),
        useMenuItem: false,
      })),
    footer: [
      {
        text: intl.formatMessage({
          id: "user.avatar.logout",
          defaultMessage: "登出",
        }),
        path: handleLocaleRoute(ROUTE_PATH.LogOut),
        show: handleShowLogout,
      },
    ]
      .filter((item) => item.show)
      .map((item, idx) => ({
        children: (
          <ListItemBasic
            textPrimary={
              <Box px={3}>
                <Typography variant="body2">{item.text}</Typography>
              </Box>
            }
            listItemProps={{
              onClick: () => navigate(item.path),
            }}
          />
        ),
        useMenuItem: false,
      })),
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
  };

  return (
    <Box display="flex">
      <Box mr={1}>
        <AvatarBasic
          avatarProps={{
            ...getAvatarProps(),
            sx: {
              width: 32,
              height: 32,
              fontSize: "12px",
            },
          }}
        />
      </Box>
      <ButtonPopup
        buttonProps={{
          variant: "text",
          text: displayName,
          endIcon: <img src={IconArrowDown} alt="arrow down" />,
        }}
        menuProps={menuProps}
      />
    </Box>
  );
};

export default UserAvatarPopup;
